<template>
  <Collapse>
    <template #label="{ toggle, isOpen }">
      <button
        class="flex w-full flex-row items-center justify-between p-4"
        @click="toggle"
      >
        <span class="text-lg">{{ $t(`sorting_select.sort_by`) }}</span>
        <IconUp v-if="isOpen" class="size-4" />
        <IconDown v-else class="size-4" />
      </button>
    </template>

    <template #collapse-content="{ close }">
      <MobileSortingItemsList
        :items="items"
        :selected="selectedSortName"
        class="w-full border-0 px-4 pb-5"
        @click:item="close"
      />
    </template>
  </Collapse>
</template>

<script lang="ts">
import MobileSortingItemsList from '~/components/sorting/MobileSortingItemsList.vue'
import Collapse from '~/components/ui/collapse/Collapse.vue'
import useSorting from '#layers/base/composables/useSorting'

export default defineComponent({
  name: 'MobileSortingMenu',
  components: {
    MobileSortingItemsList,
    Collapse,
  },
  props: {
    values: {
      type: Array as PropType<SortValue[]>,
      required: true,
    },
  },
  setup: (props) => {
    const { selectedSortName } = useSorting()
    return {
      selectedSortName,
      items: computed(() => Object.values(props.values || {})),
    }
  },
})
</script>
